// Constants and helpers for the admin Notifications screen.

// Delivery/processing status of a notification (status ∈ PENDING | SENT | SUPPRESSED | FAILED).
export const NOTIFICATION_STATUS = {
  PENDING: "PENDING",
  SENT: "SENT",
  SUPPRESSED: "SUPPRESSED",
  FAILED: "FAILED",
} as const;

export type NotificationStatus = (typeof NOTIFICATION_STATUS)[keyof typeof NOTIFICATION_STATUS];

// Options for the status filter dropdown.
export const NOTIFICATION_STATUS_OPTIONS: { value: NotificationStatus; label: string }[] = [
  { value: NOTIFICATION_STATUS.PENDING, label: "Pending" },
  { value: NOTIFICATION_STATUS.SENT, label: "Sent" },
  { value: NOTIFICATION_STATUS.SUPPRESSED, label: "Suppressed" },
  { value: NOTIFICATION_STATUS.FAILED, label: "Failed" },
];

// Catalyst <Badge> colors are a fixed set of keys; restrict to the ones we use.
type BadgeColor = "green" | "amber" | "zinc" | "red";

// Maps a notification status to its display label and badge color.
export const NOTIFICATION_STATUS_BADGE: Record<string, { label: string; color: BadgeColor }> = {
  [NOTIFICATION_STATUS.SENT]: { label: "Sent", color: "green" },
  [NOTIFICATION_STATUS.PENDING]: { label: "Pending", color: "amber" },
  [NOTIFICATION_STATUS.SUPPRESSED]: { label: "Suppressed", color: "zinc" },
  [NOTIFICATION_STATUS.FAILED]: { label: "Failed", color: "red" },
};

// Only these roles may view notifications (mirrors the API's authorization).
export const NOTIFICATIONS_ALLOWED_ROLES = [
  "SUPER_ADMIN",
  "FINLEY_ADMIN",
  "FINLEY_ORG_ADMIN",
] as const;

export const canViewNotifications = (role?: string | null): boolean =>
  !!role &&
  NOTIFICATIONS_ALLOWED_ROLES.includes(role as (typeof NOTIFICATIONS_ALLOWED_ROLES)[number]);
